import { useNavigate } from 'react-router-dom';

export default function PaymentOrderConfirmationPage() {
  const navigate = useNavigate();

  return (
    <div className="min-w-screen min-h-screen bg-[#F9F5F2] py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-2xl border border-[#E5E7EB] shadow-sm p-8 md:p-12">
          <div className="w-14 h-14 rounded-full bg-[#E7F6EF] text-[#119975] grid place-items-center mx-auto mb-5">
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M20 7L9 18L4 13"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h1 className="text-center text-[#2B3133] font-libreBaskerville text-3xl md:text-4xl mb-3">
            Gelukt, je bestelling is geplaatst!
          </h1>
          <p className="text-center text-[#889696] font-poppins text-sm md:text-base max-w-xl mx-auto">
          Je betaling is bevestigd en we hebben je bestelling ontvangen. Je persoonlijke doseringen en gebruiksadviezen staan klaar op je adviespagina.
          </p>

          <div className="mt-10 max-w-[900px] mx-auto rounded-3xl bg-[#ECE9E6] px-8 md:px-12 py-8">
            <div className="space-y-8">
              <div className="flex items-center justify-between gap-6">
                <span className="text-[#5D6470] font-poppins text-[17px] md:text-[22px] leading-none">
                  Betaalstatus
                </span>
                <span className="text-[#141729] font-poppins font-semibold text-[17px] md:text-[22px] leading-none">
                  Bevestigd
                </span>
              </div>
              <div className="h-px bg-[#D8D4CF]" />
              <div className="flex items-center justify-between gap-6">
                <span className="text-[#5D6470] font-poppins text-[17px] md:text-[22px] leading-none">
                  Bestelstatus
                </span>
                <span className="text-[#141729] font-poppins font-semibold text-[17px] md:text-[22px] leading-none">
                  Ontvangen
                </span>
              </div>
            </div>
          </div>

          <div className="mt-8 flex justify-center">
            <button
              type="button"
              onClick={() => navigate('/your-advice')}
              className="h-12 px-8 rounded-full bg-[#119975] text-white font-poppins font-medium hover:opacity-95 transition-opacity"
            >
              Naar Mijn Adviespagina
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
